import { useState, useEffect } from "react";
import api from "../../api/client";
import { PageSection } from "../PageSection";
import { PageHeader } from "../PageHeader";
import { OfferingGrid } from "../OfferingGrid";
import { groupItemsByCategory } from "../../utils/menu";

export const Catering = () => {
  const [categories, setCategories] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const itemsRes = await api.get("/menu");
        const cateringItems = (itemsRes.data || []).filter(
          (item) => item.menuId === 0
        );
        setCategories(groupItemsByCategory(cateringItems));
      } catch (err) {
        console.error(err);
        setError("Failed to load catering menu");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <PageSection className="catering" id="catering">
      <PageHeader
        className="catering-header"
        tagline="Catering"
        subtitle="Let us bring the bougie to your event!"
      />

      <div className="catering-welcome">
        <p>
          Welcome to The Lil Bougie Foodie! We love to cater events. Below are
          some of our options, priced per person. For more information, please do
          not hesitate to reach out to us at lilbougiefoodie@gmail.com.
        </p>
      </div>

      <div className="catering-menu">
        <OfferingGrid
          loading={loading}
          error={error}
          categories={categories}
          gridClassName="catering-items"
          categoryClassName="catering-category"
          loadingText="Loading catering menu..."
          emptyText="No catering items found"
          renderItem={(item) => (
            <div key={item.id} className="catering-item">
              {item.image && (
                <img
                  src={`/image_uploads/${item.image}`}
                  alt={item.name}
                  className="catering-item-image"
                  loading="lazy"
                />
              )}
              <div className="item-details">
                <h4>{item.name}</h4>
                {item.description && (
                  <span className="serving-size">{item.description}</span>
                )}
              </div>
              <span className="price">{item.price}</span>
            </div>
          )}
        />
      </div>
    </PageSection>
  );
};
